import axios from "axios";
import { useEffect, useState } from "react";
import { AuthProvider, useAuth } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import { getOidcProviderConfig, setOidcConfig } from "./api/oidcConfig";
import AuthContent from "./components/AuthContent";
import { AdminProvider } from "./context/adminContext";
import { DesignSystemProvider } from "./context/designSystemContext";
import { TenantProvider } from "./context/tenantContext";
import { AppRoutes } from "./routes";
import { getTenantInfoUrl } from "./utils/environment";

const AppContent = () => {
  const auth = useAuth();

  if (!auth.isAuthenticated) return <AuthContent />;

  return (
    <TenantProvider>
      <AdminProvider>
        <DesignSystemProvider>
          <AppRoutes />
        </DesignSystemProvider>
      </AdminProvider>
    </TenantProvider>
  );
};

export const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTenantInfo = async () => {
      try {
        setLoading(true);
        console.log("VITE_API_URL original:", import.meta.env.VITE_API_URL);
        console.log(
          "VITE_API_URL após replace:",
          import.meta.env.VITE_API_URL?.replace("/undefined", "")
        );
        const response = await axios.get(getTenantInfoUrl());
        setOidcConfig(response.data);
      } catch (error) {
        console.error("Erro ao buscar informações do tenant:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTenantInfo();
  }, []);

  if (loading && !getOidcProviderConfig()) {
    return null;
  }

  return (
    <AuthProvider {...getOidcProviderConfig()}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
};
